import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldExpressionComponent } from './field-expression.component';
import { CardComponent } from '../../../@theme/components/card/card.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { CodemirrorModule } from '@ctrl/ngx-codemirror';
import { FieldSelectModule } from '../field-select';
import { FieldTextModule } from '../field-text';

@NgModule({
  declarations: [
    FieldExpressionComponent
  ],
  exports: [
    FieldExpressionComponent
  ],
  imports: [
    CommonModule,
    CardComponent,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    FormsModule,
    CodemirrorModule,
    FieldSelectModule,
    FieldTextModule
  ]
})
export class FieldExpressionModule {
}
